<template>
  <div class="chapter-detail">
    <Reader ref="reader"
      :title="chapterTitle"
      :isFavorite="isFavorite"
      :content="list"
      @operate="operate"
      @loaded="onLoaded"
    />
    <Drawer :visible.sync="showChapter">
      <div class="chapters-container">
        <div class="chapters-header">
          <h3>Chapter</h3>
          <img src="@/assets/images/icon/ascending.png" alt="" class="icon">
        </div>
        <div>
          <div
            v-for="chapter in chapterList"
            :key="chapter.id"
            class="chapter-item"
            :class="{ active: chapter.id == chapterId }"
            @click="changeChapter(chapter)"
          >
            <p>{{ chapter.title }}</p>
            <i
              :class="['icon', (chapter.is_unlock || chapter.is_vipunlock) ? 'unlock' : 'lock']"
              ></i>
          </div>
        </div>
      </div>
    </Drawer>
    <UnlockPopup :visible.sync="unlockPopupVisible" :info="priceInfo" @success="unlockSuccess"/>
  </div>
</template>

<script>
import {
  addFavorite, deleteFavorite, getChapterDetail, getNovelChapters, getNovelDetail,
} from '@/api';

import pubSub from '@/utils/pubSub';

import Drawer from '@/components/Drawer';
import UnlockPopup from '@/components/UnlockPopup';
import { saveVisitRecords } from '@/utils/index';
import Reader from './components/Reader';

export default {
  components: { Reader, Drawer, UnlockPopup },
  data() {
    return {
      chapterTitle: '',
      list: [],
      isFavorite: false,
      showChapter: false,
      chapterId: '',
      chapterList: [],
      currentPrice: 0,
      totalPrice: 0,
      unlockPopupVisible: false,
      priceInfo: {},
    };
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    if (this.loading) {
      this.loading.close();
    }
  },
  methods: {
    async init() {
      const { params: { novelId, chapterId } } = this.$route || {};
      if (!novelId || !chapterId) return;
      this.novelId = novelId;
      this.getNovelInfo(novelId);
      this.getChapterList();
      await this.getChapterDetail(chapterId);
    },
    async getNovelInfo(id) {
      const res = await getNovelDetail(id);
      if (res.code !== 0) return;
      saveVisitRecords(res.data || {});
      this.isFavorite = Boolean((res.data || {}).is_collected);
    },
    async getChapterDetail(chapterId) {
      this.loading = this.$loading({
        backgroundColor: 'rgb(32, 37, 36)',
      });
      const res = await getChapterDetail(this.novelId, chapterId);
      this.chapterId = chapterId;
      if (res.code === 4001) {
        const work = () => {
          this.unlockChapter(res.data);
          this.loading && this.loading.close();
          this.loading = null;
        };
        this.chapterList && this.chapterList.length ? work() : pubSub.on('chapterListLoaded', work);
        return;
      }
      if (res.code !== 0) {
        this.$toast.error('error, now back to discover page');
        this.$router.go(-1);
        return;
      }
      const list = (res?.data?.content || []).map((item) => item.content);
      this.$refs.reader?.scrollToTop?.();
      this.list = list;
      this.chapterTitle = res?.data?.title;
    },
    onLoaded() { // 漫画加载完成
      this.loading && this.loading.close();
      this.loading = null;
    },
    async getChapterList() {
      const res = await getNovelChapters(this.novelId);
      if (res.code !== 0) return;
      this.chapterList = (res.data || []).sort((a, b) => a.idx - b.idx);
      this.totalPrice = this.chapterList.reduce((price, cur) => {
        if (!(cur.is_unlock || cur.is_vipunlock)) {
          price += cur.price;
        }
        return price;
      }, 0);
      pubSub.emit('chapterListLoaded');
    },
    changeChapter(item) { // 切换章节
      if (item.id === this.chapterId) return;
      if (!(item.is_unlock || item.is_vipunlock)) {
        this.unlockChapter(item);
        return;
      }
      this.showChapter = false;
      this.getChapterDetail(item.id);
    },
    unlockChapter(item) { // 解锁下一章
      const ids = [];
      this.chapterList.forEach((chapter) => {
        if (!(chapter.is_unlock || chapter.is_vipunlock)) ids.push(chapter.id);
      });
      this.priceInfo = {
        novelId: this.novelId,
        chapterId: item.id,
        unlockChapters: ids,
        single: item.price,
        total: this.totalPrice,
        title: item.title,
      };
      this.unlockPopupVisible = true;
    },
    unlockSuccess(id) { // 解锁成功
      // id 下一章id
      this.getChapterList();
      this.getChapterDetail(id);
      this.showChapter = false;
    },
    async handleFavorite() { // 收藏
      if (this.favoriteIng) return;
      this.favoriteIng = true;
      const { isFavorite } = this;
      const api = isFavorite ? deleteFavorite : addFavorite;
      const res = await api(this.novelId);
      this.favoriteIng = false;
      if (res.code !== 0) {
        this.$toast.error('Favorite Failed');
        return;
      }
      this.$toast(isFavorite ? 'Favorite Deleted' : 'Favorite Added');
      this.isFavorite = !isFavorite;
    },
    handleLast() { // 上一章
      const i = this.chapterList.findIndex((item) => String(item.id) === String(this.chapterId));
      if (i <= 0) return;
      const chapterInfo = this.chapterList[i - 1];
      this.changeChapter(chapterInfo);
    },
    handleNext() { // 下一章
      const i = this.chapterList.findIndex((item) => String(item.id) === String(this.chapterId));
      if (i === (this.chapterList.length - 1)) return;
      const chapterInfo = this.chapterList[i + 1];
      this.changeChapter(chapterInfo);
    },
    operate(type) {
      switch (type) {
        case 'chapter':
          this.showChapter = !this.showChapter;
          break;
        case 'favorite':
          this.handleFavorite();
          break;
        case 'setting':
          break;
        case 'detail':
          this.$router.push(`/novel/detail/${this.novelId}`);
          break;
        case 'last':
          this.handleLast();
          break;
        case 'next':
        case 'end':
          this.handleNext();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.chapter-detail {
  height: 100%;
  .chapters-container {
    height: 100%;
    overflow-y: scroll;
    .chapters-header {
      height: 56px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(243, 243, 243, 1);
      font-size: @fontLarge;
      font-weight: 700;
      .icon {
        width: 24px;
        height: 24px;
      }
    }
    .chapter-item {
      display: flex;
      padding: 0 16px;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: @fontMedium;
      &.active {
        color: @theme;
        .icon {
          background-image: url('~@/assets/images/icon/location.png') !important;
        }
      }
      .icon {
        .iconMixin();
        &.lock {
          background-image: url('~@/assets/images/icon/lock.png');
        }
        &.unlock {
          background-image: url('~@/assets/images/icon/unlock.png');
        }
      }
    }
  }

}

</style>
